import { Button } from 'components/atoms/button'
import { useStore } from 'hooks/useStore'
import { devMode } from 'utils/constants'

export function DidYouKnowBlock() {
	// TODO: Remove null when ready
	const { didYouKnowContent } = useStore()

	if (devMode('Hide Did You Know block')) {
		return null
	}

	return (
		<div className="p-4 rounded-2xl space-y-4 shadow-local border border-translucent-plus-border">
			<h3 className="text-xl font-medium">Did You Know?</h3>
			<p className="text-sm text-primary-text">
				{didYouKnowContent ?? `You can create your own Club and Offers for your community.`}
			</p>
			<Button variant="secondary" fullWidth disabled>
				Coming Soon
			</Button>
		</div>
	)
}
